<se-fe-card>
  <se-fe-card-content>
    <se-fe-header [seFeDataTitle]="primaryEmailDisplay" [seFeDataSubtitle]="access" seFeDataSize="500" class="persona-avatar">
      <se-fe-avatar
        seFeHeaderVisual
        seFeDataType="persona"
        seFeDataAriaLabel="full_name"
        seFeDataImgUrl=""
        [seFeDataIdentity]="guardianName"
        seFeDataSize="300">
      </se-fe-avatar>
    </se-fe-header>
    @if (moreMenuOptions) {
      <se-fe-chip seFeDataText="pending" [seFeMenuTrigger]="moreMenu">
        {{ primaryEmailDisplay }}
      </se-fe-chip>
      <se-fe-menu #moreMenu [seFeDataOptions]="moreMenuOptions"></se-fe-menu>
    }
  </se-fe-card-content>
</se-fe-card>
